import {StoreExt} from '@utils/reactExt'
import {observable, action, runInAction} from 'mobx'
import {enumToView} from '@src/utils';
import {FORMAT_TYPES} from '@src/constants';
import moment from 'moment'
import {userStore} from '@store/userStore'
class CouponStore extends StoreExt {
    @observable myCouponList: any = [];
    @observable myExchange: any[] = [];
    @observable loading: boolean = false;
    @action
    getMyCoupon = async status => {
        this.loading = true
        try {
            const res = await this.api.myCoupon({status: String(status)})
            res.map(item => {
                item.validStartTime = item.validStartTime ? moment(item.validStartTime).format(FORMAT_TYPES.SECOND) : null
                item.validEndTime = item.validEndTime ? moment(item.validEndTime).format(FORMAT_TYPES.SECOND) : null
                item.goodsReleaseName = item.goodsReleaseNames.join('、')
                item.platForm = item.platForm.split(',')
                if (item.platForm.length === 3) {
                    item.platFormName = '全平台通用'
                } else {
                    const arr = []
                    item.platForm.map(i => {
                        arr.push(enumToView('PLATFORM', i))
                    })
                    const preStr = arr.length === 1 ? '仅' : ''
                    item.platFormName = `${preStr}${arr.join(',')}可用`
                }
            })
            runInAction(() => {
                this.myCouponList = res
            })
        } catch (e) {

        } finally {
            runInAction(() => {
                this.loading = false
            })
        }
    };
    @action
    getMyExchange = async status => {
        try {
            const res = await this.api.myExchangeCoupon({status});
            runInAction(() => {
                this.myExchange = res
            })
        } catch (e) {
        }
    };
    @action
    handleExchange = async (ticketCode) => {
        try {
            this.$toast.loading('领取中，请稍后');
            const res = await this.api.checkTicket({ticketCode, simId: userStore.currentDeviceInfo.simId});
            await this.api.useTicket({
                iccid: userStore.currentDeviceInfo.simId,
                ticketCode: ticketCode,
                sign: res.sign
            });
            this.$toast.info('兑换成功');
            this.getMyExchange('1')
        } catch (e) {
        }
    }
}

const couponStore = new CouponStore()
export {
    couponStore,
    CouponStore
}
